import { useMemo } from "react";

import agreementParts from "astrid-firestore/src/api/agreements/constants/agreementParts";
import priceTypes, { cloudPriceTypes } from "astrid-firestore/src/api/prices/constants/priceTypes";

import usePriceTypes from "../../prices/hooks/usePriceTypes";

// Cloud agreements are publisher agreements but only take cloud price types, hence their own key.
export const CLOUD_PRICE_OPTIONS = "cloud";

const priceTypesByPart = {
	[agreementParts.USER]: [priceTypes.RECORD, priceTypes.EDIT, priceTypes.PROOF, priceTypes.MANAGE],
	[agreementParts.NARRATOR]: [priceTypes.READER],
	[agreementParts.SUBCONTRACTOR]: [priceTypes.PRODUCTION],
	[agreementParts.PUBLISHER]: [priceTypes.PRODUCTION, priceTypes.EXTRA],
	[CLOUD_PRICE_OPTIONS]: cloudPriceTypes,
};

export default function useCostTypeOptions(part = agreementParts.USER) {
	const names = usePriceTypes();
	const expenseNames = usePriceTypes(true);

	return useMemo(
		() =>
			(Array.isArray(part) ? part : [part])
				.map((part) =>
					(priceTypesByPart[part] || []).map((type) => ({
						key: type,
						value: type,
						// A subcontractor's production price is an expense.
						text: part === agreementParts.SUBCONTRACTOR ? expenseNames[type] : names[type],
					})),
				)
				.flat(),
		[expenseNames, names, part],
	);
}
